/* unplugin-vue-components disabled */import { render } from "./agents-list.vue?vue&type=template&id=9200bc22&scoped=true"
import script from "./agents-list.vue?vue&type=script&lang=js"
export * from "./agents-list.vue?vue&type=script&lang=js"

import "./agents-list.vue?vue&type=style&index=0&id=9200bc22&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9200bc22"],['__file',"src/pages/settings/admin/test-agents/agents-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9200bc22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9200bc22', __exports__)) {
    api.reload('9200bc22', __exports__)
  }
  
  module.hot.accept("./agents-list.vue?vue&type=template&id=9200bc22&scoped=true", () => {
    api.rerender('9200bc22', render)
  })

}


export default __exports__